// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"502ccc81","732":"f5bc1340","977":"51ded9e9"}[chunkId] + ".chunk.js";
};